import StreamType from "types/StreamType";
import AdType from "types/AdType";
import SiteType from "types/SiteType";
import { ContentType } from "types/ContentType";
import { BLOOMBERGTV_CUSTOM_KEY, QUICKTAKE_CUSTOM_KEY } from "app/utils/Constant";

interface SiteConfig {
    byAdType: Record<AdType, Partial<Record<StreamType, Record<ContentType, string>>>>,
    scriptUrl: string
}

type IXConfigType = Record<SiteType, SiteConfig>;

const IXConfig: IXConfigType = {
    [SiteType.BUSINESS]: {
        byAdType: {
            [AdType.PREROLL]: {
                [StreamType.LIVE]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "Bloomberg.com_BTV_Live_Preroll",
                    [QUICKTAKE_CUSTOM_KEY]: "Bloomberg.com_QuickTake_Live_Preroll"
                },
                [StreamType.VOD]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "Bloomberg.com_BTV_VOD_Preroll",
                    [QUICKTAKE_CUSTOM_KEY]: "Bloomberg.com_QuickTake_VOD_Preroll"
                }
            },
            [AdType.MIDROLL]: {
                [StreamType.LIVE]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "Bloomberg.com_BTV_Live_Midroll",
                    [QUICKTAKE_CUSTOM_KEY]: "Bloomberg.com_QuickTake_Live_Midroll"
                },
                [StreamType.VOD]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "Bloomberg.com_BTV_VOD_Midroll",
                    [QUICKTAKE_CUSTOM_KEY]: "Bloomberg.com_QuickTake_VOD_Midroll"
                }
            }
        },
        scriptUrl: "https://js-sec.indexww.com/ht/p/184795-45553530326378.js"
    },
    [SiteType.COJP]: {
        byAdType: {
            [AdType.PREROLL]: {
                [StreamType.LIVE]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "bloomberg.co.jp_BTV_Live_Preroll",
                    // Currently, there is no Quicktake live stream on co.jp
                },
                [StreamType.VOD]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "bloomberg.co.jp_BTV_VOD_Preroll",
                    [QUICKTAKE_CUSTOM_KEY]: "bloomberg.co.jp_QuickTake_VOD_Preroll"
                }
            },
            [AdType.MIDROLL]: {
                [StreamType.LIVE]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "bloomberg.co.jp_BTV_Live_Midroll",
                    // Currently, there is no Quicktake live stream on co.jp
                },
                [StreamType.VOD]: {
                    [BLOOMBERGTV_CUSTOM_KEY]: "bloomberg.co.jp_BTV_VOD_Midroll",
                    [QUICKTAKE_CUSTOM_KEY]: "bloomberg.co.jp_QuickTake_VOD_Midroll"
                }
            }
        },
        scriptUrl: "https://js-sec.indexww.com/ht/p/184795-221475390811523.js"
    }
};

export default IXConfig;
